import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaomedicaotemperatura(
  state = INITIAL_STATE,
  action
) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaomedicaotemperatura/FIND_OPERACAOMEDICAOTEMPERATURA':
      case '@operacaomedicaotemperatura/UPDATE_OPERACAOMEDICAOTEMPERATURA':
      case '@operacaomedicaotemperatura/DELETE_OPERACAOMEDICAOTEMPERATURA':
      case '@operacaomedicaotemperatura/STORE_OPERACAOMEDICAOTEMPERATURA':
      case '@operacaomedicaotemperatura/OPERACAOMEDICAOTEMPERATURAS_IN_REQUEST':
      case '@operacaomedicaotemperatura/UPDATE': {
        draft.loading = true;
        break;
      }

      case '@operacaomedicaotemperatura/SUCCESS_REMOVE':
      case '@operacaomedicaotemperatura/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaomedicaotemperatura/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaomedicaotemperaturas;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaomedicaotemperatura/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaomedicaotemperatura;
        break;
      }

      case '@operacaomedicaotemperatura/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
